<app-avatar [name]="name" [size]="size" [textSizeRatio]="32/14" [initialsSize]="2"
  [matTooltip]="('status.' + (status || 'offline')) | translate" [matTooltipDisabled]="!statusTooltip"></app-avatar>
<div *ngIf="!hideStatus" class="status-icon" [ngClass]="status || 'offline'" [style.border-color]="statusBackground">
</div>
